import { withRouter } from "react-router-dom";
import Header from "../../../shared/header/header";
import LandingPageFooter from "../../../shared/landing-page-footer/landing-page-footer";
import Taptop from "../../../shared/tap-top/tapTop";
import AboutSection from "../aboutSection/AboutSection";
import styles from "./layout.module.scss";

const HomeLayout: React.FC = ({ children }) => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });

  return (
    <>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header className={styles["page-header-accueil"]} />
        <div className="page-body-wrapper">
          <div className={styles["page-body-accueil"]}>{children}</div>
          <AboutSection />
          <LandingPageFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(HomeLayout);
